
import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useTopicService = (
  setTopics: React.Dispatch<React.SetStateAction<string[]>>
) => {
  // Fetch popular topics/tags
  const loadTopics = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('tags')
        .select('name, article_count')
        .order('article_count', { ascending: false })
        .limit(10);
      
      if (error) throw error;
      
      setTopics((data || []).map(tag => tag.name));
    } catch (err) {
      console.error('Error fetching topics:', err);
      setTopics([]);
    }
  }, [setTopics]);

  return { loadTopics };
};
